import { createPortal } from "react-dom";

interface SnackbarData {
  id: string;
  message: string;
  subMessage?: string;
}

interface LoadingSnackbarProps {
  snackbars: SnackbarData[]; // Now accepts an array instead of single loading boolean
}

const MultiLoadingSnackbar = ({ snackbars = [] }: LoadingSnackbarProps) => {
  // Add safety check - don't render if no snackbars
  if (!snackbars || snackbars.length === 0) {
    return null;
  }
  const SNACKBAR_HEIGHT = 120; // Height of each snackbar + gap
  const TOP_OFFSET = 90; // Starting position from top

  const snackbarContent = (
    <>
      {snackbars.map((snackbar, index) => (
        <div
          key={snackbar.id}
          style={{
            position: "fixed",
            top: `${TOP_OFFSET + index * SNACKBAR_HEIGHT}px`, // Stack vertically
            right: "16px",
            zIndex: 9999,
            transition: "top 0.3s ease-in-out",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              backgroundColor: "#F3E5F5",
              color: "#6A1B9A",
              padding: "16px",
              borderRadius: "4px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              minWidth: "320px",
              border: "1px solid #E1BEE7",
            }}
          >
            {/* Spinner */}
            <div
              style={{
                width: "24px",
                height: "24px",
                border: "3px solid #E1BEE7",
                borderTop: "3px solid #7B1FA2",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />

            <div>
              <div
                style={{ fontWeight: 500, fontSize: "0.9rem", lineHeight: 1.5 }}
              >
                {snackbar.message}
              </div>

              {snackbar.subMessage && (
                <div
                  style={{ fontSize: "0.85rem", opacity: 0.8, fontWeight: 400 }}
                >
                  {snackbar.subMessage}
                </div>
              )}

              <div
                style={{
                  fontSize: "0.8rem",
                  marginTop: "8px",
                  fontWeight: 500,
                  color: "#C62828",
                }}
              >
                ⚠️ Please do not close or refresh the page.
              </div>
            </div>
          </div>
        </div>
      ))}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );

  return createPortal(snackbarContent, document.body);
};

export default MultiLoadingSnackbar;
